import { Component, OnInit } from '@angular/core';
import { CustomerInterface } from '../../modules/account/models/customer.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerStorageService } from '../../modules/account/services/customer-storage.service';
import { Store, select } from '@ngrx/store';
import { ConstsHelper } from '../../helpers/consts.helper';
import { CustomerInterfaceState } from '../../modules/account/store/state/customer.state';
import { LoginResponseInterface } from '../../modules/authentication/models/login-response.interface';
import { ExtranetService } from '../../modules/shared/services/extranet.service';
import { SupportUserInterface } from '../../modules/shared/models/support-user.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DisplayIaChatbot } from '../../modules/shared/store/actions/display-ia-chatbot.actions';
import { UpdateDisplayNotesVisibility } from '../../modules/shared/store/actions/display-notes.actions';
import { BillInterfaceState } from '../../modules/bills/store/state/bill.state';
import { SelectedLandLineInterfaceState } from '../../modules/landlines/store/state/selected-land-line.state';
import { LineInterfaceState } from '../../modules/lines/store/state/line.state';
import { BillsInterfaceState } from '../../modules/bills/store/state/bills.state';
import { TowGService } from '../../modules/shared/services/tow-g.service';

@Component({
    selector: 'app-connected-container',
    templateUrl: './customer-area-container.component.html',
    styleUrls: ['./customer-area-container.component.css'],
    standalone: false
})
export class CustomerAreaContainerComponent implements OnInit {

  customer: CustomerInterface = null;
  supportUser: SupportUserInterface;
  brand?: string;
  hideSomeComponents: boolean;
  billId: number = null;
  landLine: string = null;
  msisdn: string = null;
  note = {
    oid: null,
    supportUserId: null,
    category: null,
    note: null
  };
  vitrineUrl?: string;
  twoGLines: Array<string>;
  isPro: boolean;

  constructor(
      private store: Store<any>,
      private router: Router,
      private customerStorageService: CustomerStorageService,
      private extranetService: ExtranetService,
      private activateRoute: ActivatedRoute,
      private http: HttpClient,
      private towGService: TowGService
  ) {}

  ngOnInit() {
    this.twoGLines = [];
    this.isPro = false;
    this.vitrineUrl = environment.data.vitrineUrl;
    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe((result: CustomerInterfaceState) => {
      if (result.customer !== null) {
        this.customer = result.customer;
        this.isPro = [null, ''].indexOf(this.customer.siret) == -1;
        this.store.dispatch(new DisplayIaChatbot(environment.data.iaChatbotUrl));
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
      if (response != null && response.line != null) {
        this.msisdn = response.line.phoneNumber;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE)).subscribe((response: SelectedLandLineInterfaceState) => {
      if (response != null && response.line != null) {
        this.landLine = response.line.phoneNumber;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_BILL)).subscribe((response: BillInterfaceState) => {
      if (response.bill != null) {
        this.billId = response.bill.id;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_BILLS)).subscribe((response: BillsInterfaceState) => {
      if (response.bills instanceof Array) {
        this.billId = response.bills[0].id;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LOGIN)).subscribe((result: LoginResponseInterface) => {
      if (result.token == null) {
        this.customer = null;
      }
    });

    this.brand = environment.data.brand;
    this.hideSomeComponents = false;
    this.customer = this.customerStorageService.getCustomer();
    this.supportUser = this.extranetService.getSupportUser();
    const splitHostname = window.location.hostname.split('.');
    if (this.supportUser === null && splitHostname.length > 0 && splitHostname[0].includes('extec')) {
      window.location.href = environment.data.url;
    }
    this.store.dispatch(new DisplayIaChatbot(environment.data.iaChatbotUrl));
    this.http.get<{ip: string}>(environment.data.ipAddressApi).subscribe(
        address => {
          localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER_IP, address.ip);
        }
    );
    this.checkParams();
    if (null === this.customer) {
      if (this.router.url === '/oubli-mdp') {
        this.router.navigate(['/oubli-mdp']);
      } else if (this.router.url === '/premiere-connexion') {
        this.router.navigate(['/premiere-connexion']);
      } else if (this.router.url.includes('/reinitialiser-mdp')) {
        this.router.navigate([this.router.url]);
      } else if (this.router.url.includes('/nouvel-email')) {
        this.router.navigate([this.router.url]);
      } else if (this.router.url.includes('/paiements/express')) {
        this.router.navigate([this.router.url]);
      } else if (this.router.url.includes('/finaliser/souscription')) {
        this.hideSomeComponents = true;
        this.router.navigate([this.router.url]);
      } else if (this.router.url.includes('/callbackUrl')) {
        this.router.navigate([this.router.url]);
        this.setCallbackRedirection();
      } else {
        this.router.navigate(['/connexion']);
      }
    } else {
      if (this.router.url === '/') {
        this.router.navigate(['/lignes/suiviconso']);
      } else if (this.router.url.includes('/finaliser/souscription')) {
        this.hideSomeComponents = true;
        this.router.navigate([this.router.url]);
      }
    }

    // generate the current brand favicon
    const link = document.createElement('link');
    link.type = 'image/png';
    link.rel = 'icon';
    document.head.appendChild(link);
    link.href = '../../assets/images/' + this.brand + '_favicon.png';

    // generate the current brand meta tag Title
    let ecName = '';
    if (this.brand === 'lacarte') {
      setInterval(function() {
        const cus = this.customerStorageService.getCustomer();
        if (
            cus !== null &&
            (
                [null, ''].indexOf(cus.email) !== -1 ||
                [null, ''].indexOf(cus.lastName) !== -1 ||
                [null, ''].indexOf(cus.firstName) !== -1
            )
        ) {
          this.router.navigate(['/mon-compte']);
        }
      }.bind(this), 500);
      ecName = 'SFR Discover';
    } else {
      ecName = this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
    }
    document.title = ecName;
    this.towGService.getList().subscribe(list => {
      this.twoGLines = list;
    });
  }

  /**
   * Callback function for login page only
   */
  private setCallbackRedirection() {
    this.activateRoute.queryParams
        .subscribe(params => {
          if (params.url && params.url !== '') {
            localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CONNEXION_CALLBACK_URL,
                JSON.stringify({url: params.url}));
          }
        });
  }

  private checkParams() {
    if (this.activateRoute.snapshot.queryParams && this.activateRoute.snapshot.queryParams['callback']) {
      localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CALLBACK,
          JSON.stringify({callback: this.activateRoute.snapshot.queryParams['callback']}));
      if (this.customer !== null) {
        window.location.href = environment.data.url + '/dimelo';
      }
    } else if (this.activateRoute.snapshot.queryParams && this.activateRoute.snapshot.queryParams['procedure']) {
      localStorage.setItem(ConstsHelper.LOCAL_STORAGE_PROCEDURE_TO_OPEN, this.activateRoute.snapshot.queryParams['procedure']);
    }
  }

  displayNotesModal() {
    this.note.oid = this.customer.id;
    this.note.note = null;
    this.note.category = null;
    switch (true) {
      case this.router.url.includes('/compte'):
        this.note.category = 'account';
        break;
      case this.router.url.includes('/lignes'):
        this.note.category = 'msisdn';
        if (this.msisdn) {
          this.note.oid = this.msisdn;
        }
        break;
      case this.router.url.includes('/fixes'):
        this.note.category = 'landline';
        if (this.landLine) {
          this.note.oid = this.landLine;
        }
        break;
      case this.router.url.includes('/factures'):
        this.note.category = 'billing';
        if (this.billId) {
          this.note.oid = this.billId.toString();
        }
        break;
      case this.router.url.includes('/paiements'):
        this.note.category = 'payment';
        break;
    }
    this.store.dispatch(new UpdateDisplayNotesVisibility(this.note));
  }

  getTwoGLines() {
    if (this.twoGLines.length == 1) {
      return ' ' + this.twoGLines[0];
    } else if (this.twoGLines.length > 1 && this.twoGLines.length < 5) {
      return ' ' + this.twoGLines.join(', ');
    } else {
      return '';
    }
  }

  getHrefValue() {
    if (this.brand == 'prixtel') {
      return 'https://assistance.prixtel.com/questions/960894-arret-2G';
    } else if (this.brand == 'coriolis') {
      return 'https://assistance.coriolis.com/questions/960885-arret-2G';
    } else {
      return null;
    }
  }
}
